	
function teamCarousel(){
    function getSlickArgs(numCols = 4) {
        return {
            autoplay: false,
            slidesToShow: numCols,
            slidesToScroll: numCols,
            arrows:true,
            dots: true,
            infinite: false,
            mobileFirst: false,
            responsive: [
                {
                    breakpoint: 999,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                },
            ]
        }
    }

    function initTeamMemberCarousels() {
        $('.m__team-carousel__slider:not(.grid-layout)').each(function(){
            $(this).slick(getSlickArgs($(this).data("num-cols")));
        });
    }
    initTeamMemberCarousels();


    // Category filter
    const filters = document.querySelectorAll('.js__team-carousel-filter');
    if (filters.length) {
        filters.forEach(filter => {
            filter.addEventListener('change', e => {
                const termId = filter.value;
                const module = filter.closest('.m__team-carousel');

                runTeamCarouselFilter(module, termId);
            })
        })
    }

    function runTeamCarouselFilter(module, termId = 'all') {
        console.log('runfilter', termId);

        // Fade out current team members
        const wrapper = module.querySelector('.m__team-carousel__col-wrapper');
        wrapper.style.height = wrapper.offsetHeight + 'px';
        wrapper.classList.add('is-faded');
        
        const reqUrl = `action=ajax_get_team_carousel&termId=${termId}`;
        fetch(scriptVars.ajaxUrl, {
			method: 'POST',
			body: reqUrl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
		})
			.then((response) => response.text())
			.then((data) => {
                // Set the new team members and init the slider
                setTimeout(() => {
                    wrapper.innerHTML = data;
                    initTeamMemberCarousels();
                    
                    // Reveal the section again
                    setTimeout(() => {
                        wrapper.style.height = 'auto';
                        wrapper.classList.remove('is-faded');
                    }, 800);
                }, 350)
			})
			.catch((error) => console.error(error));
    }



    //Add 'read more' to Bios that run too long
    let teamBioTexts = document.querySelectorAll('.m__team-carousel__bio');
    teamBioTexts.forEach((bio) => {

        if(bio.offsetHeight > 250){
            bio.classList.add('too-long');

            bio.addEventListener('click',(event) => {
                bio.classList.remove('too-long');
            })
        }

    })
}
